import React, { Component } from 'react'
import moment from 'lib/moment-timezone-custom'
import ScheduleSlot from 'frontend/schedule/schedule-slot'
import CommonIcons from 'frontend/components/common-icons'

export default class RoomSegment extends Component {
  constructor (props) {
    super(props)
    this.state = {
      room: props.room
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    this.setState({ room: nextProps.room })
  }

  renderTimeSlots () {
    return this.state.room.dates[0].timeSlots.map(
      function (timeSlot) {
        if (
          !this.props.selectedTimeRange ||
          (this.props.selectedTimeRange.from < timeSlot.time &&
            this.props.selectedTimeRange.to > timeSlot.time)
        ) {
          return (
            <ScheduleSlot
              key={timeSlot.time}
              timeSlot={timeSlot}
              room={this.state.room}
              schedule={this.props.schedule}
              selectedTime={this.props.selectedTime}
              selectedRoom={this.props.selectedRoom}
              playersCount={this.props.selectedPlayersCount}
              cartItems={this.props.cartItems}
              onSelect={this.props.onSlotSelect}
              onRemove={this.props.onGameRemove}
              onPlayersCountSelect={this.props.onPlayersCountSelect}
            />
          )
        }
      }.bind(this)
    )
  }

  renderLocation () {
    if (this.state.room && this.state.room.location) {
      return (
        <div>
          <a href={this.state.room.location.path} className="location_address">
            {this.state.room.location.address.local}
          </a>
          <div className="get_directions">
            <a href={this.state.room.location.mapUrl} target="_blank" rel="noreferrer">
              Get directions
              <CommonIcons item="common-location-arrow" className="icon" />
            </a>
          </div>
        </div>
      )
    }
  }

  renderRoomImage () {
    if (!this.state.room.image) return null

    if (this.state.room.pageOpened) {
      return (
        <a href={this.state.room.path}>
          <img src={this.state.room.image.xsmallSquare} width="68" height="68" alt={this.state.room.name} />
        </a>
      )
    } else {
      return <img src={this.state.room.image.xsmallSquare} />
    }
  }

  renderRoomName () {
    if (this.state.room.pageOpened) {
      return <a href={this.state.room.path}>{this.state.room.name}</a>
    } else {
      return <span>{this.state.room.name}</span>
    }
  }

  renderDiscountLabel () {
    if (moment(this.state.room.dates[0].date).diff(moment()) > 604800000) {
      return (
        <div className="discount_label">
          <div className="value">$10 off</div>
          <div className="description">7 Day Advance Discount is Applied</div>
        </div>
      )
    } else {
      return null
    }
  }

  render () {
    // Hide room when there is no slots
    var slots = this.renderTimeSlots()
    if (
      slots.find(function (slot) {
        return typeof slot !== 'undefined'
      })
    ) {
      return (
        <div className="schedule_room_segment" data-room-id={this.state.room.id}>
          <div className="header">
            <div className="image">{this.renderRoomImage()}</div>
            <div className="name_and_location">
              <div className="name">{this.renderRoomName()}</div>
              {this.renderLocation()}
            </div>
          </div>
          <div
            className="slots schedule_day"
            data-date={moment(this.state.room.dates[0].date).format('YYYY-MM-DD')}
          >
            {this.renderDiscountLabel()}

            {slots}
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}
